// extracted by mini-css-extract-plugin
export var active = "_1o-7";
export var container = "_1o-0";
export var evenWidth = "_1o-4";
export var large = "_1o-5";
export var outlet = "_1o-8";
export var slide = "_1o-2";
export var small = "_1o-6";
export var tab = "_1o-3";
export var tabs = "_1o-1";